import type {ReactNode} from 'react';
import {CheckOutlined, DesktopOutlined, MoonOutlined, SunOutlined} from '@ant-design/icons';
import clsx from 'clsx';

import type {ThemeChoice} from '@atoms/theme';
import {useThemeChoice} from '@hooks/useTheme';

import styles from './ThemePicker.module.scss';

// Три tile с миниатюрой интерфейса (Светлая / По системе / Тёмная).
// Используется в SettingsPage и PersonalizationModal.
export const ThemePicker = () => {
  const [choice, setChoice] = useThemeChoice();

  return (
    <div className={styles.row}>
      <ThemeOption
        value="light"
        label="Светлая"
        icon={<SunOutlined />}
        mode="light"
        active={choice === 'light'}
        onSelect={setChoice}
      />
      <ThemeOption
        value="auto"
        label="По системе"
        icon={<DesktopOutlined />}
        mode="auto"
        active={choice === 'auto'}
        onSelect={setChoice}
      />
      <ThemeOption
        value="dark"
        label="Тёмная"
        icon={<MoonOutlined />}
        mode="dark"
        active={choice === 'dark'}
        onSelect={setChoice}
      />
    </div>
  );
};

/* ─── Tile ─────────────────────────────────────────────────────── */

type ThemeOptionProps = {
  value: ThemeChoice;
  label: string;
  icon: ReactNode;
  mode: 'light' | 'dark' | 'auto';
  active: boolean;
  onSelect: (value: ThemeChoice) => void;
};

const ThemeOption = ({value, label, icon, mode, active, onSelect}: ThemeOptionProps) => {
  const handleClick = () => onSelect(value);

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-pressed={active}
      aria-label={label}
      className={clsx(styles.tile, active && styles.tileActive)}
    >
      <div className={clsx(styles.preview, styles[`preview_${mode}`])}>
        <div className={styles.previewSidebar} />
        <div className={styles.previewContent}>
          <div className={styles.previewBar} />
          <div className={styles.previewBarShort} />
        </div>
      </div>
      <div className={styles.label}>
        <span className={styles.icon}>{icon}</span>
        <span>{label}</span>
        {active && <CheckOutlined className={styles.check} />}
      </div>
    </button>
  );
};
